import Cookies from 'js-cookie';

export const REFERRAL_ID_COOKIE_NAME = 'air_referral_id';

export const getReferralCookies = () => {
  return Cookies.get(REFERRAL_ID_COOKIE_NAME);
};
